import axios from "axios";
import { hasObject } from "util";
export const baseURL = process.env.NODE_ENV !== "production" ? "/zdbc/" : "";

/**
 * 返回API接口的状态类型
 *
 * @export
 * @param {*} code
 * @param {*} type
 * @param {*} cb
 */
export function apiReturnType(code, type, cb) {
  if (code > 0) {
    Message.success(`${type}成功`);
    if (typeof cb === "function") cb();
  } else if (type === "删除") {
    if (code === -3) Message.warning(`无法${type}（别的表用到该条数据）`);
    else Message.error(`${type}失败`);
  } else if (code === 0) Message.error(`${type}失败`);
  else if (code === -1) Message.warning(`${type}失败，数据已存在`);
}

/**
 * 封装axios插件
 */
export const ajaxT = axios.create({ baseURL });

export function download(url, options) {
  let parameter = "";
  if (options && options.params) {
    const params = options.params;
    if (hasObject(params)) {
      let count = 0;
      for (let key in params) {
        parameter += count === 0 ? "?" : "&";
        parameter += `${key}=${params[key]}`;
        count++;
      }
    } else if (params) parameter = params;
  }
  window.open(`${baseURL}${url}${parameter}`);
}

export function cdownload(url, options) {
  let parameter = "";
  if (options) {
    const params = options;
    if (hasObject(params)) {
      let count = 0;
      for (let key in params) {
        parameter += count === 0 ? "?" : "&";
        parameter += `${key}=${params[key]}`;
        count++;
      }
    } else if (params) parameter = params;
  }
  window.open(`${baseURL}${url}${parameter}`);
}
